export const ADD_PARAMETERS = 'ADD_PARAMETERS';

export const addParameters = parameters => {
    return {
        type: ADD_PARAMETERS,
        payload: parameters
    }
};



// WEBPACK FOOTER //
// ./src/actions/ParametersActions.js